import { render, staticRenderFns } from "./followuprejectedfrm.vue?vue&type=template&id=31a10352&"
import script from "./followuprejectedfrm.vue?vue&type=script&lang=js&"
export * from "./followuprejectedfrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports